import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Link from 'react-router-dom/Link';

const ErrorCode = styled.h1`
  margin-top: 8rem;
  font-size: 5rem;
  margin-bottom: 0px;
`;

class PageNotFound extends Component {
  render() {
    return (
      <div className="container">
        <div className="text-center">
          <ErrorCode>404</ErrorCode>
          <p className="lead text-gray-800 mb-2">
            <FormattedMessage id="PageNotFound.PageNotFound" />
          </p>
          <Link to="/">
            <FormattedMessage id="PageNotFound.BackHomeLink" />
          </Link>
        </div>
      </div>
    );
  }
}

export default PageNotFound;
